
















import { Component, Vue } from "vue-property-decorator";
import Oportunities from "@/components/Oportunities.vue";
import Mission from "@/components/Mission.vue";
@Component({
  components: {
    Oportunities,
    Mission
  }
})
export default class Home extends Vue {
  mounted () {
    window.analytics.page('Home');
  }
}
